import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PercentageEditControlComponent),
    multi: true
};

/**
 * Percentage edit
 */
@Component({
    selector: "wbo-percentage-edit-control",
    templateUrl: "./percentage-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class PercentageEditControlComponent extends AbstractEditControlComponent {

    /**
     * Number of decimal places
     */
    @Input() public decimalPlaces: number = 1;

    constructor(injector: Injector) {
        super(injector);
    }
}
